import { BenefitCard } from '../components/BenefitCard'
import { BENEFITS } from '../../config/home.config'

export function Benefits() {
  return (
    <section className="bg-surface border border-border rounded-xl shadow-card">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 divide-y lg:divide-y-0 lg:divide-x divide-border">
        {BENEFITS.map((item) => (
          <BenefitCard key={item.label} item={item} />
        ))}
      </div>
    </section>
  )
}
